import { render, staticRenderFns } from "./M524BottomDrawer.vue?vue&type=template&id=d6112ab0&scoped=true&"
import script from "./M524BottomDrawer.vue?vue&type=script&lang=js&"
export * from "./M524BottomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./M524BottomDrawer.vue?vue&type=style&index=0&id=d6112ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6112ab0",
  null
  
)

export default component.exports